import React from "react";
import PropTypes from "prop-types";
import CheckListContainer from "../../../../features/document/edit/checklist/components/CheckListContainer";

const OfferCheckListContainer = ({ documentId, siteId }) => {
  return (
    <>
      <CheckListContainer documentId={documentId} siteId={siteId} />
    </>
  );
};

OfferCheckListContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number
};

export default OfferCheckListContainer;
